// Enhanced mock data for MJ Audio - Service Provider Model

export const heroSlides = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/ix1hjac1_4.jpg",
    alt: "Luxury Home Theater Installation"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/939iomwa_AIM_4841.JPG",
    alt: "MJ Audio Office - Premium Cinema Room"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/tgcf8vmp_AIM_4842.JPG",
    alt: "MJ Audio Office - Professional Setup"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/s2fn6oa0_AIM_4844.JPG",
    alt: "MJ Audio Office - Dolby Atmos Display"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/kswa9wsm_AIM_4887.JPG",
    alt: "MJ Audio Office - High-End Theater Equipment"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Homeowner, Chennai",
    rating: 5,
    text: "MJ Audio transformed our living room into a spectacular home cinema. The Dolby Atmos setup is breathtaking, and their attention to acoustic detail is unmatched.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
    project: "7.2.4 Dolby Atmos Home Theater"
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Architect, Bangalore",
    rating: 5,
    text: "Professional service from start to finish. They understood our design requirements and delivered a seamless integration. Highly recommended for premium projects.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
    project: "Luxury Villa Home Cinema"
  },
  {
    id: 3,
    name: "Vikram Reddy",
    role: "Business Owner, Hyderabad",
    rating: 5,
    text: "Best decision for our home theater. The calibration work is phenomenal - every movie feels like a real cinema experience. Worth every rupee invested.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
    project: "9.2.6 Reference Cinema Room"
  }
];

export const services = [
  {
    id: 1,
    title: "Home Theater Design",
    slug: "home-theater-design",
    description: "Complete home cinema design from concept to reality. Custom layouts, acoustic planning, and premium equipment selection.",
    icon: "Home",
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/944b8m0n_home-theater-1.jpg",
    features: ["Custom Room Design", "Acoustic Planning", "Equipment Selection", "3D Visualization"],
    longDescription: "Our home theater design service transforms your vision into reality. We handle everything from room analysis and acoustic treatment to equipment selection and aesthetic integration."
  },
  {
    id: 2,
    title: "Professional Installation",
    slug: "professional-installation",
    description: "Expert installation of all audio-video components with precision wiring, mounting, and system integration.",
    icon: "Settings",
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/pd8hnf4g_installation-2.jpg",
    features: ["Professional Wiring", "Equipment Mounting", "Cable Management", "System Integration"],
    longDescription: "Our certified technicians ensure flawless installation with meticulous attention to detail, proper cable management, and seamless equipment integration."
  },
  {
    id: 3,
    title: "Dolby Atmos & Vision",
    slug: "dolby-atmos-vision",
    description: "Immersive 3D audio with Dolby Atmos and stunning HDR visuals with Dolby Vision for the ultimate cinema experience.",
    icon: "Volume2",
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/ckrlvpxc_dolby-atmos%20-%203.jpg",
    features: ["Atmos Setup", "Height Speakers", "4K HDR", "Vision Calibration"],
    longDescription: "Experience cinema-grade immersive audio and stunning visuals with our Dolby Atmos and Dolby Vision installation and calibration services."
  },
  {
    id: 4,
    title: "Acoustic Treatment",
    slug: "acoustic-treatment",
    description: "Professional acoustic analysis, treatment, and optimization for perfect sound quality in your cinema room.",
    icon: "Waves",
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/xoaytn4e_acoustic%20-4.jpg",
    features: ["Room Analysis", "Acoustic Panels", "Bass Traps", "Sound Isolation"],
    longDescription: "Transform your room's acoustics with our scientific approach to sound treatment. We analyze, design, and install custom acoustic solutions."
  },
  {
    id: 5,
    title: "Calibration Services",
    slug: "calibration-services",
    description: "Precision audio-video calibration using professional tools for reference-grade picture and sound quality.",
    icon: "Sliders",
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/yfgs5hh7_calibration%20-5.jpg",
    features: ["Audio Calibration", "Video Calibration", "Room EQ", "Reference Standards"],
    longDescription: "Our expert calibration ensures your system performs at its peak with reference-grade audio and video settings tailored to your room."
  },
  {
    id: 6,
    title: "Consultation & Support",
    slug: "consultation-support",
    description: "Expert consultation for planning, upgrades, and ongoing support for your home cinema investment.",
    icon: "MessageSquare",
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/90cfgyyc_Support-6.jpg",
    features: ["Free Consultation", "System Upgrades", "Technical Support", "Maintenance"],
    longDescription: "Get expert guidance throughout your home cinema journey with our comprehensive consultation and ongoing support services."
  }
];

export const projects = [
  {
    id: 1,
    title: "Luxury Villa Home Cinema",
    location: "Bangalore",
    type: "Residential",
    system: "9.2.4 Dolby Atmos",
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/1ujvb3gl_Bangalore%20Project%201.jpg",
    description: "Premium home theater with custom acoustic treatment and reference-grade components",
    year: "2024"
  },
  {
    id: 2,
    title: "Modern Apartment Theater",
    location: "Barani Nagar",
    type: "Residential",
    system: "7.2.4 Dolby Atmos",
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/1r4i9cxs_Barani%20Nagar%204.jpeg",
    description: "Compact yet powerful cinema solution with immersive surround sound",
    year: "2024"
  },
  {
    id: 3,
    title: "Penthouse Cinema Room",
    location: "Maharaja Nagar",
    type: "Residential",
    system: "11.2.6 Reference Setup",
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/dtsbp5gj_Maharaja%20Nagar%204.jpeg",
    description: "Ultimate reference cinema with cutting-edge technology and acoustics",
    year: "2023"
  },
  {
    id: 4,
    title: "RR Cinemas Installation",
    location: "Chennai",
    type: "Commercial",
    system: "Premium Theater System",
    image: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/l9lu6dnr_RR%20Cinemas%2010.jpeg",
    description: "Professional cinema installation with luxury seating and premium audio",
    year: "2023"
  }
];

export const brands = [
  { 
    name: "Denon", 
    category: "AV Receivers & Amplifiers", 
    logo: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/rvoa7dcl_Denon.png" 
  },
  { 
    name: "Marantz", 
    category: "Premium Audio Components", 
    logo: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/tuljez1k_Marantz.png" 
  },
  { 
    name: "XTZ", 
    category: "Swedish High-End Speakers", 
    logo: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/cn6e5mkd_XTZ.png" 
  },
  { 
    name: "Epson", 
    category: "4K Laser Projectors", 
    logo: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/0eg94ie1_Epson.png" 
  },
  { 
    name: "Pulz", 
    category: "Professional Audio Systems", 
    logo: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/okcpkzic_Pulz.png" 
  },
  { 
    name: "AudioControl", 
    category: "Professional Audio Processing", 
    logo: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/ez2kbrup_Audio%20control.png" 
  },
  { 
    name: "ARCAM", 
    category: "High-End Audio", 
    logo: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/5b1zzckv_Arcam.png" 
  },
  { 
    name: "IOTAVX", 
    category: "Integrated Amplifiers", 
    logo: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/to4biwqv_IOTA%20VX.png" 
  },
  { 
    name: "Monoprice", 
    category: "Professional Accessories", 
    logo: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/kekwcoqq_Monoprice.png" 
  },
  { 
    name: "Optoma", 
    category: "Projection Technology", 
    logo: "https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/viegy40a_OptomaLogo.png" 
  }
];

export const stats = [
  { value: "15+", label: "Years Experience" },
  { value: "500+", label: "Projects Completed" },
  { value: "4.9", label: "Client Rating" },
  { value: "100%", label: "Satisfaction Rate" }
];

export const expertise = [
  {
    icon: "Award",
    title: "Certified Professionals",
    description: "Our team holds industry certifications in audio-video installation, calibration, and acoustic design."
  },
  {
    icon: "Users",
    title: "Experienced Team",
    description: "Over 15 years of combined experience in home cinema design, installation, and calibration services."
  },
  {
    icon: "Shield",
    title: "Quality Assurance",
    description: "Every project undergoes rigorous quality checks and professional calibration before handover."
  },
  {
    icon: "Heart",
    title: "Customer Focused",
    description: "We prioritize your vision and requirements, delivering personalized solutions that exceed expectations."
  }
];

export const whyChooseUs = [
  {
    title: "Unrivaled Expertise",
    description: "Over 15 years specializing in premium home theater design, installation, and calibration services across South India.",
    icon: "1"
  },
  {
    title: "End-to-End Solutions",
    description: "From initial consultation and design to installation, calibration, and after-sales support - we handle it all.",
    icon: "2"
  },
  {
    title: "Premium Brand Partners",
    description: "Authorized partners of world-class audio-video brands ensuring genuine products and expert support.",
    icon: "3"
  },
  {
    title: "Custom Tailored Approach",
    description: "Every project is unique. We design and implement solutions perfectly matched to your space and preferences.",
    icon: "4"
  }
];

export const businessInfo = {
  name: "MJ Audio — The Real Cinema",
  tagline: "Premium Home Theater & Audio-Video Solutions",
  address: "Plot No. 5/1, Ground Floor, Near Income Tax Office, Rahmath Nagar, Kamaraj Nagar, Tirunelveli, Tamil Nadu 627011",
  landline: "0462-3593978",
  whatsapp: "919629326015",
  email: "raja@mjaudio.in",
  hours: "10:00 AM to 9:00 PM",
  rating: 4.9,
  established: "2011",
  yearsExperience: "13+",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3948.8!2d77.7!3d8.7!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwNDInMDAuMCJOIDc3wrA0MicwMC4wIkU!5e0!3m2!1sen!2sin!4v1234567890"
};

export const aboutContent = {
  mission: "To deliver exceptional home cinema experiences through expert design, installation, and calibration services, transforming homes into personal theaters.",
  vision: "To be South India's most trusted name in premium home theater solutions, known for excellence, innovation, and unparalleled customer satisfaction.",
  values: [
    "Excellence in every project",
    "Customer satisfaction first",
    "Continuous innovation",
    "Integrity and transparency"
  ]
};
